export const localStorageEffect =
  (key: string) =>
  ({
    setSelf,
    onSet
  }: {
    setSelf: (value: any) => void;
    onSet: (
      callback: (newValue: any, oldValue: any, isReset: boolean) => void
    ) => void;
  }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      try {
        setSelf(JSON.parse(savedValue));
      } catch (e) {
        console.error('Failed to parse stored organization:', e);
        localStorage.removeItem(key);
      }
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };
